export const getCompanyName = (legalStatus, companyName, contactFirstName, contactLastName) => {
  return legalStatus === "Individual" ? `${contactFirstName}  ${contactLastName}` : companyName;
};
